<template>
  <v-card>
    <v-form>
      <v-card-title>
        <span class="headline">Detail Merchant</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <data-detail-row
            label="Source Onboarding"
            :data="editedItem"
            :valueData="editedItem.source_onboarding"
            noGutters
          />
          <data-detail-row
            label="Nama Merchant"
            :data="editedItem"
            :valueData="editedItem.merchant_name"
            noGutters
          />
          <data-detail-row
            label="Reference No"
            :data="editedItem"
            :valueData="editedItem.reference_number"
            noGutters
          />
          <data-detail-row
            label="Kode Wilayah"
            :data="editedItem"
            :valueData="editedItem.kode_wilayah"
            noGutters
          />
          <data-detail-row
            label="Merchant Type"
            :data="editedItem"
            :valueData="editedItem.tipe_merchant"
            noGutters
          />
          <data-detail-row
            label="Tanggal Pengajuan"
            :data="editedItem"
            :valueData="editedItem.created_at"
            noGutters
          />
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  components: { DataDetailRow: () => import('../detail/DataDetailRow.vue') },
  props: ['editedItem'],
  methods: {
    close() {
      this.$emit('closeParent');
    },
  },
};
</script>
